import axios from 'axios'

const API_HOST = process.env.REACT_APP_API_HOST
const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL
const BACKEND_ACCESS_KEY = process.env.REACT_APP_BACKEND_ACCESS_KEY

const handler = ({ baseURL = API_HOST, url = null, method = 'get', args = {}, isFile = false }) => {
  const request = {}

  request.url = url
  request.baseURL = baseURL
  request.method = method.toLowerCase()
  
  // Initialize headers
  request.headers = {
    backendAccessKey: BACKEND_ACCESS_KEY
  }
  
  // Only set Content-Type for non-file requests
  // For file uploads, let axios automatically set Content-Type with boundary
  if (!isFile) {
    request.headers['Content-Type'] = 'application/json'
  }

  // Add authentication headers
  const authentication = window.localStorage.getItem('authentication')
  const authorization = window.localStorage.getItem('authorization')
  
  // Validate tokens
  const isValidAuth = authentication && authentication !== 'null' && authentication !== 'undefined' && authentication.trim() !== ''
  const isValidAuthz = authorization && authorization !== 'null' && authorization !== 'undefined' && authorization.trim() !== ''
  
  // Add appropriate headers based on which tokens are available
  // Admin routes need 'authentication' header, userAdmin routes need 'authorization' header
  if (isValidAuth) {
    request.headers.authentication = authentication
    // Also add for nginx CORS compatibility if no user token
    if (!isValidAuthz) {
      request.headers.authorization = authentication
    }
  }
  
  if (isValidAuthz) {
    request.headers.authorization = authorization
  }
  // If no valid tokens, don't add the headers at all

  if (request.method === 'get') request.params = args
  else request.data = args

  return axios(request).then(
    response => {
      return response.data
    },
    async error => {
      if (error?.response) {
        if (
          error.response.data.error === 'jwt expired' ||
          error.response.data.error === 'UnAuthorized - Authorization required!'
        ) {
          window.localStorage.removeItem('authentication')
          window.localStorage.removeItem('authorization')
          window.localStorage.removeItem('adminData')
          window.localStorage.removeItem('userData')
          window.location.href = PUBLIC_URL + '/login'
        }
        return error.response.data
      } else {
        return {}
      }
    }
  )
}

export default handler
